
import {DEV_LOCAL, DEV_AWS, PROD_AWS, PROD_LOCAL, PROD_SA_TABLE,
  DEV_SA_TABLE} from "../../lib/constants";

const get_execution_mode = () => {

  if (!process.env.REACT_APP_MODE) {
    return DEV_LOCAL;
  }
  return process.env.REACT_APP_MODE;
};

const is_development_mode = () => {
  const mode = get_execution_mode();
  return mode === DEV_LOCAL || mode === DEV_AWS;
};

const is_production_mode = () => {
  const mode = get_execution_mode();
  return mode === PROD_AWS || mode === PROD_LOCAL;
};

const is_local_mode = () => {
  const mode = get_execution_mode();
  return mode === DEV_LOCAL || mode === PROD_LOCAL;
};

const is_aws_mode = () => {
  const mode = get_execution_mode();
  return mode === DEV_AWS || mode === PROD_AWS;
};

const get_wlf_table = wlf_id => {
  if (is_production_mode()) {
    return 'prod-' + wlf_id;
  }

  if (is_development_mode()) {
    return 'dev-' + wlf_id;
  }

  throw new Error("Unknown mode" + get_execution_mode(), console.trace());
};

const get_wlf_master_table = () => {
  if (is_production_mode()) {
    return "prod-WLF";
  }
  return "dev-WLF";
}

const get_sa_table = () => {
  if (is_production_mode()) {
    return PROD_SA_TABLE;
  }
  if (is_development_mode()) {
    return DEV_SA_TABLE;
  }
  throw new Error("Mode " + get_execution_mode() + "unknown");
};


export { get_execution_mode, is_development_mode, is_production_mode,
  is_local_mode, is_aws_mode, get_wlf_table, get_sa_table,
  get_wlf_master_table };
